<template>
  <div>
    <van-steps
      v-if="fancy"
      direction="vertical"
      :active="quizHistory.length - 1"
    >
      <van-step v-for="(result, index) in quizHistory" :key="index">
        <h3 v-if="result.data && result.data.score">
          【sprkrs】
          <span v-if="result.data.score > 90">💥💥💥</span>
          <span v-else-if="result.data.score > 80">💥💥</span>
          <span v-else-if="result.data.score > 70">💥</span>
          <span v-else>0</span>
        </h3>
        <p>{{ formatDatetime(result.created) }}</p>
      </van-step>
    </van-steps>
    <ol v-else class="quiz-history-list">
      <li v-for="(result, index) in quizHistory" :key="index">
        {{ formatDatetime(result.created) }}
        <small>({{ formatFromNow(result.created) }})</small>:
        {{ $t("stats.percentage", [result.data.score]) }}
      </li>
    </ol>
  </div>
</template>

<script>
import formatTS from "@/mixins/momentMixin";
export default {
  name: "BoxQuizHistory",
  mixins: [formatTS],
  props: {
    quizHistory: { type: Array, required: true },
    fancy: { type: Boolean, default: true }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles.scss";

ol.quiz-history-list {
  overflow-y: auto;
  min-height: 25px;
  max-height: 20vh;
  margin-left: 16px !important;
  margin-right: 16px !important;
  width: 100%;
  list-style: inside decimal !important;
}
</style>
